import { render, staticRenderFns } from "./NkChart18.vue?vue&type=template&id=faa43f7c&scoped=true"
import script from "./NkChart18.vue?vue&type=script&lang=js"
export * from "./NkChart18.vue?vue&type=script&lang=js"
import style0 from "./NkChart18.vue?vue&type=style&index=0&id=faa43f7c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "faa43f7c",
  null
  
)

export default component.exports